import React from 'react';
import { StyleSheet, View, Image, Platform, Vibration, TouchableOpacity, TouchableNativeFeedback, Modal, LayoutAnimation, Switch, AppState, TextInput } from 'react-native';
import { Container, Header, Content, Button, Text, Icon, Toast, Left, Body, Right, Spinner, Footer, Title } from 'native-base';
import NetInfo from '@react-native-community/netinfo';
import { Feather } from '@expo/vector-icons';
import * as Updates from 'expo-updates';
import { Col, Row, Grid } from 'react-native-easy-grid';
//import { NavigationActions, StackActions } from 'react-navigation';
import { connect } from 'react-redux';
//import Modal from "react-native-modalbox";
import LocalStorage from '../../api/LocalStorage';
import * as LocalAuthentication from 'expo-local-authentication';
import jwt_decode from 'jwt-decode';
import CalCalDataApi from '../../api/CalCalDataApi';
import Alert from '../../components/alert';

//import ChangePin from './changePin';
//uses SET_JWT from loginReducer
import styles from './styles';
import ChangePin from './changePin';
import doDemo from '../Intro/doDemo';

const Btn = TouchableOpacity;
const loginRnd = 'https://app.calc.al/login?_rnd=' + Math.random();

/* FINGERPRINT

https://docs.expo.io/versions/latest/sdk/fingerprint.html

*/
const MAX_LENGTH = 6;

function makeDots(num) {
	let ret = '';
	while (num > 0) {
		ret += ' ○ ';
		num--;
	}
	return ret;
}

class Pin extends React.Component {
	constructor(props) {
		super(props);

		//console.log(this.props.navigation.state);

		this.state = {
			hasFingerSensor: false,
			fingersEnrolled: false,
			gettingFinger: false,
			fingerFails: 0,
			savedPin: false,
			value: '',
			loading: true,
			gotFinger: false,
			shouldSavePin: false,
			online: true,
			connectionInfo: '',
			tryTextInput: true,
			appState: 'active'
		};
	}

	static navigationOptions = {
		backBehavior: 'none',
		drawerLockMode: 'locked-closed'
	};

	componentDidMount() {
		this.checkFingerStuff();
		//console.log(this.props.user);
		if (this.props.user && this.props.user.temppin) {
			//from signup screen... mobile remembers this, but if logged out WILL forget
			this.props.navigation.navigate({ name: 'Pin', params: { change: 'temp' } });
		}
		console.log(Platform.OS);
		this.checkLocalStorageForToken();
		//demo
		if (this.props.user.demo) {
			console.log('DEMO', this.props.user);
			/*this.props.navigation.dispatch(
				StackActions.reset({
					index: 0,
					key: null,
					actions: [NavigationActions.navigate({ name: 'Drawer' })]
				})
			);*/
		}

		NetInfo.fetch().then(connectionInfo => {
			if (!connectionInfo || connectionInfo == 'unknown') return;
			__DEV__ && console.log(connectionInfo);
			//this.setState({ online: connectionInfo.isConnected, connectionInfo: JSON.stringify(connectionInfo) });
		});

		AppState.addEventListener('change', this._handleAppStateChange);
		//NetInfo.addEventListener('connectionChange', this.handleConnectivityChange.bind(this));
		//this.checkDeviceForHardware();
		//this.checkForFingerprints();
		//this.checkForSavedPIN(); //check if saved first. The either show 'save PIN' with OK, or popup 'scan' thingy and start auth
	}

	componentWillUnmount() {
		try {
			AppState.removeEventListener('change', this._handleAppStateChange);
			this.state.hasFingerSensor && Platform.OS == 'android' && LocalAuthentication.cancelAuthenticate();
		} catch (e) {} //try??
		//NetInfo.removeEventListener('connectionChange', this.handleConnectivityChange);
	}

	handleConnectivityChange(connectionInfo) {
		this.setState({ online: connectionInfo.type != 'none' });
	}

	componentDidUpdate() {
		if (this.state.tryTextInput && !!this.inputRef) this.inputRef.focus();
	}
	/*
	checkDeviceForHardware = async () => {
		let hasFingerSensor = await LocalAuthentication.hasHardwareAsync();
		this.setState({ hasFingerSensor });
		console.log('hasFingerSensor:', hasFingerSensor);
	};

	checkForFingerprints = async () => {
		let fingersEnrolled = await LocalAuthentication.isEnrolledAsync();
		this.setState({ fingersEnrolled });
		console.log('fingersEnrolled:', fingersEnrolled);
	};

	checkForSavedPIN = async () => {
		pin = await LocalStorage.getPinAsync();
		this.setState({ savedPin: pin });
		if (savedPin && this.state.hasFingerSensor && this.state.fingersEnrolled) this._getFingerPrint();
		//console.log('savedPin:', pin);
	};
*/

	_handleAppStateChange = nextAppState => {
		if (this.state.appState.match(/inactive|background/) && nextAppState === 'active') {
			this.checkLocalStorageForToken();
		}
		this.setState({ appState: nextAppState });
	};

	async checkFingerStuff() {
		const { params } = this.props.route;
		if (params && !!params.change) return;
		const [hasFingerSensor, fingersEnrolled, savedPin] = await Promise.all([LocalAuthentication.hasHardwareAsync(), LocalAuthentication.isEnrolledAsync(), LocalStorage.getPinAsync()]);
		this.setState({ hasFingerSensor, fingersEnrolled, savedPin, shouldSavePin: hasFingerSensor && fingersEnrolled });
		__DEV__ && console.log(hasFingerSensor, fingersEnrolled, savedPin);
		if (!!savedPin && hasFingerSensor && fingersEnrolled) this._getFingerPrint();
	}

	cancelFinger() {
		try {
			Platform.OS == 'android' && LocalAuthentication.cancelAuthenticate();
		} catch (e) {}
		this.setState({ gettingFinger: false, fingerFails: 0, gotFinger: false, submitting: false });
	}

	async _getFingerPrint() {
		this.setState({ gettingFinger: true, shouldSavePin: true });
		const finger = await LocalAuthentication.authenticateAsync({ promptMessage: 'Scan to use saved CalCal PIN', fallbackLabel: 'Use PIN', disableDeviceFallback: true });
		//LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
		//this.setState({gettingFinger:false});
		if (finger && finger.success) {
			console.log('finger successs');
			LayoutAnimation.configureNext(LayoutAnimation.create(200, 'easeInEaseOut', LayoutAnimation.Properties.scaleXY));
			this.setState({ value: this.state.savedPin, fingerFails: -1, gettingFinger: false, gotFinger: true });
			this.handleOk(true);
		} else if (finger && !finger.success) {
			console.log('finger fail', finger.error);
			if (finger.error == 'user_cancel') {
				this.setState({ fingerFails: 0, gettingFinger: false });
			} else {
				this.setState({ fingerFails: this.state.fingerFails + 1, gettingFinger: false }, () => this._getFingerPrint());

				//this.setState({gettingFinger:false});
			}
		}
		//get saved PIN??
	}

	async checkLocalStorageForToken() {
		if (Platform.OS !== 'web') return this.setState({ loading: false });
		//    ************************     WEB ONLY    *********************************
		//this.setState({ loading: true });
		const jwt = await LocalStorage.getJWT();
		__DEV__ && console.log('checkLocalStorageForToken : ', jwt, this.props.user);

		if (jwt) {
			//will find in localstorage if JWT still valid: no need for PIN
			console.log('JWT still valid');
			this.setState({ loading: false });
			this.onSuccessfulPin(jwt.token);
		} else if (this.props.user.refreshTime == '9999999999') {
			//LocalStorage gives this by default, until it's corrected here
			//before we can show the PIN screen, we should check the access_token has not expired. That will be a (async) fetch

			let response = await fetch(loginRnd, {
				method: 'GET',
				headers: {
					Accept: 'application/json'
				}
			});

			if (!response) {
				console.log('No response! Redirecting...');
				window.location = loginRnd;
			}
			let result;

			try {
				result = await response.json();

				if (!(result.success && result.ok)) {
					console.log('token not OK. Redirecting...', result);
					//no need to fix this.setState({ loading: false });
					window.location = loginRnd;
				} else if (result.demo) {
					doDemo(result.demo, this.props.dispatch);
				} else {
					//this will reload the app!
					console.log('login says we have a cookie');
					this.setState({ loading: false });
					this.props.dispatch({
						type: 'SET_USER',
						user: { access_token: 'in-your-serveronly-https-cookie', refreshTime: result.expires, needspin: result.temppin }
					});
					if (result.nopin) this.props.navigation.navigate({ name: 'Pin', params: { change: 'nopin' } });
					if (result.temppin) this.props.navigation.navigate({ name: 'Pin', params: { change: 'temp' } });
				}
			} catch (e) {
				console.warn('ERROR DATA GOT', response);
				return;
			}
		} else if (this.props.user.refreshTime < new Date().getTime() / 1000) {
			//expiry has been set previously
			console.log('previously set token not OK. Redirecting...');

			if (!__DEV__) window.location = loginRnd;
			__DEV__ && console.warn('Go To https://app.calc.al/dev.php');
			__DEV__ && console.error('You have not updated the dev token in Localstorage.web.js YO DEV!!!!');
			__DEV__ && console.warn('Go to https://app.calc.al/dev.php');
			__DEV__ && console.error('You have not updated the dev token in Localstorage.web.js  YO DEV!!!!');
		} else {
			//token is fine and real
			if (__DEV__) this.setState({ loading: false }); //for dev
		}
	}

	logOut() {
		LocalStorage.removeUserAsync();
		this.props.dispatch({
			type: 'CLEAR_USER'
		});
		if (Platform.OS == 'web') {
			window.location = 'https://calcal.uk/log-out';
		} /*else {
			Updates.reloadAsync();
		}*/
	}

	handleClear() {
		this.setState({ value: '', submitting: false });
	}

	handlePress(num) {
		Vibration.vibrate(12);
		let { value } = this.state;
		value += String(num);

		if (value.length == MAX_LENGTH) {
			this.setState({ value, tryTextInput: false }, () => this.handleOk());
		} else {
			this.setState({ value, tryTextInput: false });
		}
	}

	handleTextChange(value) {
		this.setState({ value });
	}

	async handleOk(fromFinger = false, pin = null) {
		var value = pin || this.state.value;

		const savingPin = !fromFinger && !!this.state.shouldSavePin;
		//send off pin, async waiting
		//if okay, this.onSuccessfulPin
		if (value.length < 4) return;
		this.setState({ submitting: !fromFinger });
		const res = await CalCalDataApi.pinLogin(value, this.props.user?.access_token);
		if (__DEV__) console.log(res); //then onSuccess

		this.handleClear();
		if (res.token) {
			savingPin && LocalStorage.savePinAsync(value); //only save if correct!
			if (Platform.OS == 'web') LocalStorage.saveJWT({ token: res });

			this.onSuccessfulPin(res);
		} else {
			this.setState({ submitting: false, gettingFinger: false, gotFinger: false, fingerFails: 0 });
			if (res.error == 'pin') LocalStorage.removePinAsync(); //just in case
			if (res.error == 'invalid_token') {
				this.props.dispatch({
					type: 'SET_USER',
					user: false
				});
				if (Platform.OS == 'web') window.location = loginRnd;
			}
			if (res.error == 'nomembership') {
				Alert.alert('No membership', res.errorDesc);
				return Platform.OS == 'web' ? (window.location = 'https://calcal.uk/membership-account/membership-levels/') : this.props.navigation.navigate({ name: 'SubscriptionContainer' });
				//this.props.navigation.navigate('Profile');
			} else {
				//console.log(this.state);
				//toast
				Alert.alert('Login error', res.errorDesc || 'Server error... please try again');
			}

			Vibration.vibrate(120);
		}
	}

	//this should be an action but hey
	async onSuccessfulPin(token) {
		//dispatch action PIN_SUCCESS which will update the currentUser
		//if there's stuff in the
		let userinfo;
		try {
			userinfo = jwt_decode(token.token);
		} catch (e) {
			LocalStorage.removeUserAsync();
			return this.setState({ loading: false });
		}
		this.setState({
			loading: false,
			gotFinger: false
		});
		this.props.dispatch({
			type: 'SET_JWT',
			token: token,
			info: userinfo
		});
		if (__DEV__) console.log('userInfo: ', userinfo);

		//see if we have saved initLoad matching username...
		const initLoad = await LocalStorage.getInitLoad(userinfo.sub);
		if (!!initLoad) {
			console.log('loading Prev saved stuff');
			this.props.dispatch({
				type: 'Init/InitLoad',
				data: initLoad
			});

			const returnTo = this.props.route.params && this.props.route.params.returnTo; //allows a navigate on success (eg. subscription change)
			if (returnTo) this.props.navigation.navigate(returnTo);
		} else {
			this.setState({ loading: true });
		}
		//this.props.dispatch(NavigationActions.navigate('Drawer'));
		//this.props.navigation.navigate("Drawer");

		//bat off the loadInit start - whether we loaded previous or not
		this.loadInitStore(token, userinfo);
	}

	loadInitStore(token, userinfo) {
		//if JWT info comes back saying needspin PIN required, this will redirect to PIN+temp AFTER initLoad
		const nav = this.props.navigation;
		CalCalDataApi.dataLoad('initLoad', token.token, res => {
			if (!res.error && !res.exception) {
				console.log('GOT and saving initLoad');
				LocalStorage.saveInitLoad(userinfo.sub, res);
				this.props.dispatch({
					type: 'Init/InitLoad',
					data: res
				});
			}
			if (userinfo.user.needspin) {
				this.props.navigation.navigate({ name: 'Pin', params: { change: 'temp' } });
			}

			//console.log('initLoad ', res);
		});
	}

	unPin() {
		LocalStorage.removePinAsync(); //nothing on web
		//need to reset and make sure we don't end up still on PIN screen if logged in

		this.props.navigation.navigate({ name: 'Pin', params: { change: false } });
		setTimeout(
			() =>
				this.props.dispatch({
					type: 'SET_JWT',
					token: null,
					info: null
				}),
			1200
		);

		//Updates.reloadAsync();
	}

	handleRemove() {
		const { value } = this.state;
		this.setState({ value: value.substr(0, value.length - 1) });
	}

	renderButton = num => (
		<Btn style={styles.btn} onPress={() => this.handlePress(num)}>
			<Text style={styles.btntxt}>{num}</Text>
		</Btn>
	);

	makeHeader(headText, backButton = false, backToPin = false) {
		const username = (this.props.user && this.props.user.userName) || '';
		return (
			<Header>
				<Left>
					<Button
						transparent
						onPress={() => {
							backToPin ? this.props.navigation.navigate({ name: 'Pin', params: { change: false, backToPin: false } }) : this.props.navigation.goBack();
						}}>
						{
							//why? in case we need back from forgot!}

							backButton ? <Icon name="ios-arrow-back" /> : <Image source={require('../../../assets/C-white.png')} style={{ width: 30, height: 32 }} />
						}
					</Button>
				</Left>
				<Body style={{ flex: 1.5 }}>
					<Title>{headText || `Welcome back ${username}`}</Title>
				</Body>
				<Right>
					<Button transparent onPress={() => this.logOut()} style={{ flexDirection: 'column' }}>
						<Icon name="log-out" style={{ fontSize: 14 }} />
						<Text note style={{ color: 'white', alignSelf: 'center', margin: 0 }}>
							Log Out
						</Text>
					</Button>
				</Right>
			</Header>
		);
	}

	render() {
		const { value } = this.state;
		const marks = value.replace(/./g, ' ● ');
		const dots = makeDots(MAX_LENGTH - value.length);
		const canEnter = this.state.value.length >= 4 && this.state.fingerFails >= 0;
		const { gettingFinger, gotFinger, submitting, loading } = this.state;
		const { params } = this.props.route;
		var change = params && params.change;
		if (change == 'false') change = false;
		const backToPin = params && params.backToPin;
		//__DEV__ && console.log(params);
		//console.log(change);
		//const returnTo = params && params.returnTo; //allows a navigate on success (eg. subscription change)

		//console.log(this.props.user);
		//console.log(`gotFinger ${gotFinger}, params`, this.props.navigation.state);
		//If reset / forgot: let changePin handle most of that....
		if (!!change && change != 'nopin')
			return (
				<Container style={{ flex: 1 }}>
					{this.makeHeader('Reset PIN', true, backToPin)}
					<ChangePin navigation={this.props.navigation} accessToken={this.props.user?.access_token} reason={change} pin={value} reset={() => this.unPin()} login={pin => this.handleOk(false, pin)} />
				</Container>
			);

		if (!this.state.online)
			return (
				<Container style={{ flex: 1 }}>
					{this.makeHeader()}
					<Content style={styles.pad} scrollEnabled={false}>
						<Text>Your are offline. Please connect to the internet to continue</Text>
						<Text>{this.state.connectionInfo}</Text>
					</Content>
				</Container>
			);

		return (
			<Container style={{ flex: 1, backgroundColor: 'white' }}>
				{this.makeHeader(change && 'Choose PIN')}
				<Content style={styles.pad} scrollEnabled={false}>
					<View style={{ flex: 1, justifyContent: 'center', flexDirection: 'row' }}>
						{submitting || loading ? (
							<View style={{ flex: 1 }}>
								<Spinner color="#438eb9" style={{ flex: 1, marginVertical: 20 }} />
								<Text style={[styles.btntxt, { fontSize: 30 }]}>{this.state.loading ? 'Loading your data...' : 'Checking PIN...'}</Text>
								{submitting && (
									<Button
										transparent
										style={{ marginTop: 15, alignSelf: 'center' }}
										onPress={() => {
											this.cancelFinger();
										}}>
										<Text>Cancel</Text>
									</Button>
								)}
							</View>
						) : (
							<View style={[styles.pad, { maxWidth: 400 }]}>
								<Text style={styles.header}>{!!change && change == 'nopin' ? 'Please choose a 4-6 digit PIN number' : 'Please enter your PIN:'}</Text>
								<View padder style={{ flex: 1, paddingVertical: 15 }}>
									{Platform.OS == 'web' ? (
										<TextInput
											style={[styles.pin]}
											value={value}
											ref={ref => {
												if (ref) this.inputRef = ref;
											}}
											autoFocus
											secureTextEntry
											keyboardType="number-pad"
											enablesReturnKeyAutomatically
											showSoftInputOnFocus={false}
											placeholder="○  ○  ○  ○  ○  ○"
											maxLength={6}
											onChangeText={v => this.handleTextChange(v)}
											onEndEditing={() => this.handleOk()}
											inputStyle={{ fontSize: 30 }}
											onKeyPress={e => e.nativeEvent.key == 'Enter' && !this.state.loading && this.handleOk()}
										/>
									) : (
										<Text style={styles.pin}>
											{marks}
											{dots}
										</Text>
									)}
								</View>

								<View>
									<View style={styles.row}>
										{this.renderButton(1)}
										{this.renderButton(2)}
										{this.renderButton(3)}
									</View>

									<View style={styles.row}>
										{this.renderButton(4)}
										{this.renderButton(5)}
										{this.renderButton(6)}
									</View>

									<View style={styles.row}>
										{this.renderButton(7)}
										{this.renderButton(8)}
										{this.renderButton(9)}
									</View>
									<View style={[styles.row, { paddingVertical: 10 }]}>
										<Btn style={styles.btn} onPress={() => this.handleRemove()}>
											<Feather name="delete" style={[styles.btntxt, { color: 'red', fontSize: 30 }]} />
										</Btn>

										{this.renderButton(0)}

										{canEnter ? (
											<Btn style={styles.btn} onPress={() => this.handleOk()}>
												<Icon name="ios-checkmark-circle" style={[styles.btntxt, { paddingTop: 5, color: 'green', fontSize: 30 }]} />
											</Btn>
										) : (
											<Btn style={[styles.btn, { backgroundColor: 'transparent', borderWidth: 0 }]} />
										)}
									</View>
								</View>

								{canEnter && !this.state.loading && !this.state.submitting && this.state.hasFingerSensor && this.state.fingersEnrolled && (
									<View style={{ flexDirection: 'row', paddingLeft: 30, marginTop: 10, width: '90%', height: 40, alignItems: 'center' }}>
										<Icon name="finger-print" style={{ fontSize: 30, alignSelf: 'center', marginRight: 10 }} />
										<TouchableOpacity style={{ flex: 1 }} onPress={() => this.setState({ shouldSavePin: !this.state.shouldSavePin })}>
											<Text style={{ width: '100%', paddingHorizontal: 10, textAlignVertical: 'center' }}>Use your fingerprint next time</Text>
										</TouchableOpacity>
										<Switch style={{ alignSelf: 'flex-end', margin: 0 }} value={this.state.shouldSavePin} onValueChange={val => this.setState({ shouldSavePin: val })} />
									</View>
								)}
							</View>
						)}
					</View>

					{(gettingFinger || gotFinger) && (
						<Modal
							animationType="fade"
							transparent={true}
							backdropOpacity={0.2}
							visible={gettingFinger || gotFinger}
							presentationStyle="overFullScreen"
							onRequestClose={() => {
								this.setState({ gettingFinger: false });
								console.log('Modal has been closed.');
							}}>
							<View style={{ flex: 1, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(50,50,50,0.5)' }}>
								{!gotFinger && (
									<View style={{ backgroundColor: 'white', width: 300, alignItems: 'center' }}>
										{!!this.state.fingerFails && <Text>Please try again ({this.state.fingerFails})</Text>}
										<Icon name="finger-print" style={{ marginTop: 50, marginBottom: 15, fontSize: 40, height: 45, alignSelf: 'center' }} />
										<Text>Scan your fingerprint now</Text>
										<Button
											transparent
											style={{ marginTop: 15, alignSelf: 'center' }}
											onPress={() => {
												this.cancelFinger();
											}}>
											<Text>Cancel</Text>
										</Button>
									</View>
								)}
								{gotFinger && (
									<View style={{ backgroundColor: 'white', width: 300, alignItems: 'center' }}>
										<Icon name="checkmark" style={{ marginTop: 50, marginBottom: 15, fontSize: 40, height: 45, alignSelf: 'center', color: 'green' }} />
										<Text>Fingerprint OK</Text>
										<Button
											transparent
											style={{ marginTop: 15, alignSelf: 'center' }}
											onPress={() => {
												this.cancelFinger();
											}}>
											<Text>Cancel</Text>
										</Button>
									</View>
								)}
							</View>
						</Modal>
					)}
				</Content>
				{!this.state.loading && (
					<Footer transparent>
						<Button transparent onPress={() => this.props.navigation.navigate({ name: 'Pin', params: { change: 'forgot', backToPin: true } })}>
							<Text>Forgot PIN</Text>
						</Button>
					</Footer>
				)}
			</Container>
		);
	}
}

const mapStateToProps = state => ({
	user: state.loginReducer.user,
	busDetails: state.globalReducer.busDetails
	//online: state.network.isConnected
});

export default connect(mapStateToProps)(Pin);
